import { Button } from 'antd';
import React, { FC, useCallback, useMemo, useRef, useState } from 'react';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { UploadOutlined } from '@ant-design/icons';
import CSVReader from 'react-csv-reader';
import FlatfileImporter from '../flatfile/FlatfileImporter';
import { REGEX_CONFIG_NAMES, regexRecordHook } from '../flatfile/faltfile_utils';

const FlatfileUploader: FC<any> = ({ onDataUpload }) => {
	const hiddenFileInput = useRef(null);

	const [canOpenImporter, setCanOpenImporter] = useState(false);
	const [dataFromFile, setDataFromFile] = useState([]);
	const [fileInfo, setFileInfo] = useState(null);
	const [originalFile, setOriginalFile] = useState(null);

	const flateFileHeaders: any[] = useMemo(
		() => [
			{
				label: 'Asset ID',
				key: 'assetId',
				type: 'number',
				alternates: ['Asset ID'],
				constraints: [{ type: 'required' }],
			},
			{
				label: 'Impairment Adjustment',
				key: 'impairmentAdjustment',
				type: 'number',
				alternates: ['Impairment Adjustment'],
				constraints: [{ type: 'required' }],
			},
			{
				label: 'Date (MM/DD/YYYY)',
				key: 'date',
				type: 'string',
				alternates: ['Date (MM/DD/YYY)'],
				constraints: [{ type: 'required' }],
			},
		],
		[]
	);

	const _onEditEquLevelComplete = () => setCanOpenImporter(false);

	const getArrayValue = useCallback(
		(arr, index) => (nullSafeGet('length', arr) > index ? arr[index] : undefined),
		[]
	);

	const papaparseOptions = {
		dynamicTyping: true,
		skipEmptyLines: true,
	};

	const onFileLoaded = useCallback(
		(data, fileInfo, originalFile) => {
			setDataFromFile(
				data
					.map((_) => ({
						assetId: getArrayValue(_, 0),
						impairmentAdjustment: getArrayValue(_, 1),
						date: getArrayValue(_, 2),
					}))
					.slice(1)
			);
			setFileInfo(fileInfo);
			setOriginalFile(originalFile);
			setCanOpenImporter(true);
			return false;
		},
		[getArrayValue]
	);

	const handleClick = useCallback(() => hiddenFileInput.current.click(), []);

	const onFlatfileDataSubmit = useCallback(
		(results) => onDataUpload(results.validData, fileInfo, originalFile),
		[fileInfo, onDataUpload, originalFile]
	);

	return (
		<>
			<Button size="large" type="primary" onClick={handleClick}>
				<UploadOutlined />
				Upload
			</Button>
			<CSVReader
				parserOptions={papaparseOptions}
				onFileLoaded={onFileLoaded}
				ref={hiddenFileInput}
				inputStyle={{ display: 'none' }}
			/>
			<FlatfileImporter
				dataLoadComplete={canOpenImporter}
				type="asset_impairments"
				fields={flateFileHeaders}
				data={dataFromFile}
				onComplete={_onEditEquLevelComplete}
				onDataLoad={onFlatfileDataSubmit}
				recordHook={regexRecordHook([REGEX_CONFIG_NAMES.SIMPLE_DATE])}
			/>
		</>
	);
};

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
});

export default withRouter<any, any>(connect(mapStateToProps)(FlatfileUploader));
